import React from "react";
import PropTypes from "prop-types";
import { Form, Col } from "react-bootstrap";

export default function FormRow(props) {
  return (
    <Form.Row className="d-flex align-items-end">
      {props.rightJustified ? <Col /> : null}
      {props.columns.map((column, index) =>
        props.rightJustified ? (
          <Col key={column.props.label + String(index)} xs="auto">
            {column}
          </Col>
        ) : props.autoSizedColumns ? (
          props.autoSizedColumns[index] ? (
            <Col key={column.props.label + String(index)} xs="auto">
              {column}
            </Col>
          ) : (
            <Col key={column.props.label + String(index)}>{column}</Col>
          )
        ) : (
          <Col key={column.props.label + String(index)}>{column}</Col>
        )
      )}
    </Form.Row>
  );
}

FormRow.propTypes = {
  autoSizedColumns: PropTypes.array,
  columns: PropTypes.array.isRequired,
  rightJustified: PropTypes.bool
};
